import Ably from 'ably';

const ably = new Ably.Realtime(process.env.VUE_APP_ABLY_API_KEY);

export default ably;
